module.exports = __webpack_public_path__ + "img/about-03.5d66a8f0.webp";